import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Error from '../pages/Error';
import Home from '../pages/Home';
import Contact from '../pages/Contact';
import About from '../pages/About';
import Realisation from '../pages/Realisation';
import Price from '../pages/Price';

const Roads = () => {
    const location = useLocation();
    return (
        <Routes location={location} key={location.key}>
            <Route path="/" element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/realisation" element={<Realisation />} />
            <Route path="/tarif" element={<Price />} />

            <Route path="/oac" element={<Home />} />
            <Route path='/oac/about' element={<About />} />
            <Route path="/oac/contact" element={<Contact />} />
            <Route path="/oac/realisation" element={<Realisation />} />
            <Route path="/oac/tarif" element={<Price />} />

            <Route path='*' element={<Error />} />
        </Routes>
    )
}

export default Roads;